export const pageLoadTime = new Date();

// eslint-disable-next-line import/no-mutable-exports
export let reloadMarker: Date | null = null;

export const setReloadMarker = (loadTime: string | null) => {
  reloadMarker = loadTime ? new Date(loadTime) : null;
};
